const logger = {
    info: (message, data = null) => {
      const logMessage = {
        timestamp: new Date().toISOString(),
        level: 'INFO',
        message,
        data
      };
      console.log(JSON.stringify(logMessage));
    },
    warn: (message, data = null) => {
      const logMessage = {
        timestamp: new Date().toISOString(),
        level: 'WARN',
        message,
        data
      };
      console.warn(JSON.stringify(logMessage));
    },
    error: (message, error = null) => {
      const logMessage = {
        timestamp: new Date().toISOString(),
        level: 'ERROR',
        message,
        error: error?.message || error,
        stack: error?.stack
      };
      console.error(JSON.stringify(logMessage));
    },
    debug: (message, data = null) => {
      const logMessage = {
        timestamp: new Date().toISOString(),
        level: 'DEBUG',
        message,
        data
      };
      console.debug(JSON.stringify(logMessage));
    }
  };

  export default logger;